// extracted by mini-css-extract-plugin
module.exports = {"categoryMenu":"_3TBTo3kfl37ZOkEVQfjHkP","item":"_2PRDtJhLfwPXpmT3WBymaJ"};